import { render } from "./RelatedDiscussions.vue?vue&type=template&id=1a1a8072&scoped=true"
import script from "./RelatedDiscussions.vue?vue&type=script&lang=js"
export * from "./RelatedDiscussions.vue?vue&type=script&lang=js"

import "./RelatedDiscussions.vue?vue&type=style&index=0&id=1a1a8072&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a1a8072"]])

export default __exports__